import React from "react";
import { Row, Col, Form, FormControl, InputGroup, Button } from "react-bootstrap";
import Select from "react-select";
import { GetCuponsByEstabelecimento } from "../../providers/CuponsProvider";

export default class FilterBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      estabelecimento_selecionado_filtro: null, // Estabelecimento selecionado no filtro
      etabelecimentos: [], // todos estabelecimentos
      status_atividade: [
        { label: "Ativo", value: true },
        { label: "Inativo", value: false },
      ], // Status de atividade de estabelecimento
      status_atividade_selecionado_filtro: null, // Status selecionado no filtro
      nome_codigo_filtro: "", // Nome ou código do cupom no filtro
    };
    this.handleOnChange = this.handleOnChange.bind(this);
  }
  componentDidMount = async () => {
    this.setState({
      estabelecimentos: this.props.estabelecimentos,
    });
  };
  handleOnChange = (event) => this.setState({ [event.target.name]: event.target.value });

  filtrarCupons = async () => {
    let cupons = this.props.cupons;
    let {
      nome_codigo_filtro,
      estabelecimento_selecionado_filtro,
      status_atividade_selecionado_filtro,
    } = this.state;
    if (nome_codigo_filtro)
      cupons = cupons.filter(
        (cupom) => cupom.codigo.toUpperCase() === nome_codigo_filtro.toUpperCase(),
      );
    if (estabelecimento_selecionado_filtro)
      cupons = await GetCuponsByEstabelecimento(estabelecimento_selecionado_filtro.value);
    if (status_atividade_selecionado_filtro)
      cupons = cupons.filter(
        (cupom) => cupom.ativo === status_atividade_selecionado_filtro.value,
      );

    this.props.handleCupons(cupons);
  };
  limparFiltroCupons = async () => {
    await this.props.limparFiltroCupons();
  };

  render() {
    return (
      <>
        <Row>
          <Col md={12}>
            <h5>Filtros</h5>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Estabelecimento</Form.Label>
              <Select
                placeholder="Estsabelecimento"
                value={this.state.estabelecimento_selecionado_filtro}
                options={this.state.estabelecimentos}
                onChange={(opt) =>
                  this.setState({ estabelecimento_selecionado_filtro: opt })
                }
                isClearable
              ></Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Atividade</Form.Label>
              <Select
                placeholder="Status"
                value={this.state.status_atividade_selecionado_filtro}
                options={this.state.status_atividade}
                onChange={(opt) =>
                  this.setState({
                    status_atividade_selecionado_filtro: opt,
                  })
                }
                isClearable
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Nome/Código</Form.Label>
              <InputGroup>
                <Col>
                  <FormControl
                    placeholder="Nome/Código"
                    value={this.state.nome_codigo_filtro}
                    name="nome_codigo_filtro"
                    onChange={this.handleOnChange}
                  />
                </Col>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col>
            <Button
              variant="primary"
              style={{ marginTop: "25%" }}
              onClick={this.filtrarCupons}
            >
              Aplicar Filtro
            </Button>
          </Col>
          <Col md={0}>
            <Button
              style={{ marginTop: "25%" }}
              variant="secondary"
              onClick={() => {
                this.limparFiltroCupons();
              }}
            >
              Limpar
            </Button>
          </Col>
          <Col>
            <Button
              style={{ marginTop: "25%" }}
              onClick={() => {
                this.props.handleModal();
              }}
            >
              Cadastrar
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
